import { render, staticRenderFns } from "./section-content.vue?vue&type=template&id=d839600c&scoped=true&"
import script from "./section-content.vue?vue&type=script&lang=js&"
export * from "./section-content.vue?vue&type=script&lang=js&"
import style0 from "./section-content.vue?vue&type=style&index=0&id=d839600c&lang=scss&scoped=true&"
import style1 from "./section-content.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d839600c",
  null
  
)

export default component.exports